import { render, staticRenderFns } from "./NinthMobileSection.vue?vue&type=template&id=4f03e049&scoped=true&"
import script from "./NinthMobileSection.vue?vue&type=script&lang=js&"
export * from "./NinthMobileSection.vue?vue&type=script&lang=js&"
import style0 from "./NinthMobileSection.vue?vue&type=style&index=0&id=4f03e049&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f03e049",
  null
  
)

export default component.exports